import React from 'react';
import { ComparisonTableContentfulModel } from 'src/api/models/ComparisonTable';
import ComparisonTable from 'src/organisms/tables/ComparisonTable';
import styled from 'styled-components';

const DynamicComparisonTableContainer = styled.div`
  width: 100%;
  min-width: 300px;
`

export default function getDynamicComparisonTable(comparisonTableProps: ComparisonTableContentfulModel): React.ReactNode {
  return (
    <DynamicComparisonTableContainer>
      <ComparisonTable
        head={comparisonTableProps.head}
        rows={comparisonTableProps.rows}
        hideCheckIconText={comparisonTableProps.hideCheckIconText}
        responsiveBreakpoint={comparisonTableProps.responsiveBreakpoint}
        responsiveCellPadding={comparisonTableProps.responsiveCellPadding}
      />
    </DynamicComparisonTableContainer>
  )
}
